import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TranscriptCompletedHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type TranscriptCompletedHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type TranscriptCompletedHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type TranscriptCompletedHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type TranscriptCompletedHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type TranscriptCompletedHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type TranscriptCompletedHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type TranscriptCompletedHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type TranscriptCompletedHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type TranscriptCompletedHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type TranscriptCompletedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type TranscriptCompletedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type TranscriptCompletedHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type TranscriptCompletedHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type TranscriptCompletedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type TranscriptCompletedHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type TranscriptCompletedHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type TranscriptCompletedHeaderFragment = TranscriptCompletedHeader_NotificationGroupAccessRequestApproved_Fragment | TranscriptCompletedHeader_NotificationGroupAccessRequestDenied_Fragment | TranscriptCompletedHeader_NotificationGroupAccessRequestSubmitted_Fragment | TranscriptCompletedHeader_NotificationGroupAssetAssignedToYou_Fragment | TranscriptCompletedHeader_NotificationGroupAssetStatusChanged_Fragment | TranscriptCompletedHeader_NotificationGroupCommentCreated_Fragment | TranscriptCompletedHeader_NotificationGroupCommentCreatedShareAccess_Fragment | TranscriptCompletedHeader_NotificationGroupFileUploaded_Fragment | TranscriptCompletedHeader_NotificationGroupReplyCreated_Fragment | TranscriptCompletedHeader_NotificationGroupReplyCreatedShareAccess_Fragment | TranscriptCompletedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | TranscriptCompletedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | TranscriptCompletedHeader_NotificationGroupTranscriptCompletedSelf_Fragment | TranscriptCompletedHeader_NotificationGroupTransferBatchCompleted_Fragment | TranscriptCompletedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | TranscriptCompletedHeader_NotificationGroupUserMentioned_Fragment | TranscriptCompletedHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type TranscriptCompletedHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const TranscriptCompletedHeaderContent = /*#__PURE__*/ gql`
    fragment TranscriptCompletedHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
    ...AssetName
  }
}
    ${UserName}
${Text}
${AssetName}` as unknown as DocumentNode<TranscriptCompletedHeaderContentFragment, unknown>;
export const TranscriptCompletedHeader = /*#__PURE__*/ gql`
    fragment TranscriptCompletedHeader on NotificationGroup {
  ... on NotificationGroupTranscriptCompletedSelf {
    content {
      layout {
        ...TranscriptCompletedHeaderContent
      }
    }
  }
}
    ${TranscriptCompletedHeaderContent}` as unknown as DocumentNode<TranscriptCompletedHeaderFragment, unknown>;

        

        
export const useTranscriptCompletedHeaderFragment = (
  input: string | Omit<UseFragmentOptions<TranscriptCompletedHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<TranscriptCompletedHeaderFragment>({
    fragment: TranscriptCompletedHeader,
    fragmentName: 'TranscriptCompletedHeader',
    ...options,
  });
};
  
        
        

        
export const useTranscriptCompletedHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<TranscriptCompletedHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<TranscriptCompletedHeaderContentFragment>({
    fragment: TranscriptCompletedHeaderContent,
    fragmentName: 'TranscriptCompletedHeaderContent',
    ...options,
  });
};
  
        